import React from 'react'
import { Container } from 'react-bootstrap'
import Estimates from '../components/presentations/estimates'
import { useBreakpoint } from '../hooks'
import Layout from '../layout'

const EstimateContainer = () => {
	const { BREAKPOINT, screenBiggerThan} = useBreakpoint()
	const isBiggerThanXL = screenBiggerThan(BREAKPOINT.XL)

	return (
		<Layout>
			<Container fluid={!isBiggerThanXL}>
				<Estimates />
			</Container>
		</Layout>
	)
}

export default EstimateContainer
